import React, {useState, useRef} from 'react';
import {useSelector} from 'react-redux';
import {RootState} from 'modules';
// import {
//     convertSecondToTime,
//     getProgressBarTimeByHandler,
//     getProgressBarPostitionByTime,
//     getWidth,
// } from "lib/utils";
import {IVodInfoData} from 'lib/api/vodInfo';
import Progress from 'components/player/controlbar/Progress';

/**
 * 재생 바 컨테이너
 */
const ProgressContainer = () => {
  const {vodData, playingTime} = useSelector((state: RootState) => ({
    vodData: state.vodInfo.titleFileInfo.data,
    playingTime: state.video.playingTime,
  }));
  const progressRef = useRef<HTMLDivElement>(null);
  const thumbnailRef = useRef<HTMLDivElement>(null);
  const [progressMove] = useState({
    time: '',
    position: 0,
    top: 0,
    left: 0,
  });

  const {response} = vodData as IVodInfoData;
  let totalDuration: number = 0; // ms단위
  if (response.info.total_duration) {
    totalDuration = response.info.total_duration;
  }

  /**
   * @TODO 유튜브는 마우스 올리면 썸네일 안나옴. 하단의 편집 쪽에 집중한듯. 우리도 필요없을 것 같은데 어차피 하단에 있으니.
   * 재생 바에 마우스 올리면 나오는 해당 위치 시간
   */
  // const onProgressMouseMove = (e: MouseEvent) => {
  //     if (progressRef.current && thumbnailRef.current) {
  //         const time = getProgressBarTimeByHandler(
  //             e,
  //             progressRef.current,
  //             totalDuration,
  //         );

  //         const position = getProgressBarPostitionByTime(totalDuration, time);

  //         const thumbnailOffsetLeft = thumbnailRef.current.offsetLeft;
  //         const thumbnailAreaWidth = getWidth(thumbnailRef.current);
  //         const thumbnailRight = thumbnailOffsetLeft + thumbnailAreaWidth;

  //         let videoLayerRight = 0;
  //         let videoLayerOffsetLeft = 0;
  //         const videoLayer = document.getElementById("videoLayer");
  //         if (videoLayer) {
  //             videoLayerOffsetLeft = videoLayer.offsetLeft;
  //             videoLayerRight = videoLayerOffsetLeft + getWidth(videoLayer);

  //             let left = 0;
  //             if (thumbnailOffsetLeft < videoLayerOffsetLeft) {
  //                 left = videoLayerOffsetLeft;
  //             } else if (videoLayerRight <= thumbnailRight) {
  //                 left = videoLayerRight - thumbnailAreaWidth - 1;
  //             }

  //             const rect = thumbnailRef.current.getBoundingClientRect();

  //             setProgressMove({
  //                 time: convertSecondToTime(time),
  //                 position: position,
  //                 top: rect.top,
  //                 left: left + rect.left,
  //             });
  //         }
  //     }
  // };
  // useEffect(() => {
  //     if (progressRef.current) {
  //         progressRef.current.addEventListener(
  //             "mousemove",
  //             onProgressMouseMove as any,
  //         );
  //     }
  //     return () => {
  //         if (progressRef.current) {
  //             progressRef.current.removeEventListener(
  //                 "mousemove",
  //                 onProgressMouseMove,
  //             );
  //         }
  //     };
  // }, [onProgressMouseMove]);

  return (
    <Progress
      playingTime={playingTime}
      totalDuration={totalDuration}
      progressRef={progressRef}
      thumbnailRef={thumbnailRef}
      progressMove={progressMove}
    />
  );
};

export default ProgressContainer;
